import { formatNumber, formatTaka } from '@/utils/number';
import type { PcmpRequestedList } from '../../types/pcmpRequested.types';

interface PcmpDivisionTotalsProps {
  divisionTotals: NonNullable<PcmpRequestedList['divisionTotals']>;
  regionTotals: PcmpRequestedList['regionTotals'];
}

/** The tab's proposals and amount by division, with the regions under each. */
export function PcmpDivisionTotals({ divisionTotals, regionTotals }: PcmpDivisionTotalsProps) {
  if (divisionTotals.length === 0) return null;

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6">
      {divisionTotals.map((total) => {
        const regions = (regionTotals ?? []).filter((region) => region.division === total.division);
        return (
          <div
            key={total.division}
            className="flex flex-col gap-1 rounded-xl border bg-card px-4 py-3 shadow-sm"
          >
            <span className="text-xs text-muted-foreground">{total.division}</span>
            <span className="text-lg font-semibold tabular-nums">{formatTaka(total.amount)}</span>
            <span className="text-xs text-muted-foreground tabular-nums">
              {formatNumber(total.count)} proposals
            </span>
            {regions.length > 1 ? (
              <ul className="mt-1 flex flex-col gap-0.5 border-t pt-1 text-xs text-muted-foreground">
                {regions.map((region) => (
                  <li key={region.region} className="flex justify-between gap-2 tabular-nums">
                    <span className="truncate">{region.region}</span>
                    <span>{formatNumber(region.count)}</span>
                  </li>
                ))}
              </ul>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
